<template>
  <div style="margin-left: 30px" v-loading="loading">
    <div style="margin-bottom: 20px; text-align: center">
      <el-menu
        style="margin-top: -20px"
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleOpen"
      >
        <el-menu-item index="0">
          <span>基本设置</span>
        </el-menu-item>
        <el-menu-item index="1" router="true">
          <span slot="title">栏目限制</span>
        </el-menu-item>
        <el-menu-item index="2">
          <span>额度限制</span>
        </el-menu-item>
        <el-menu-item index="3">
          <span>设备信息</span>
        </el-menu-item>
        <el-menu-item index="4">
          <span>修改记录</span>
        </el-menu-item>
        <el-tooltip class="item" effect="light" placement="left" :value="true">
          <div slot="content" style="color: #f56c6c; font-size: 14px">
            <b
              ><i class="el-icon-message-solid"></i> 修改配置后请点击此处保存</b
            >
          </div>
          <el-button
            style="text-align: center; float: right; margin-top: 26px"
            size="small"
            type="primary"
            @click="submit"
            >确定</el-button
          >
        </el-tooltip>
      </el-menu>
    </div>

    <div style="margin-top: 10px" v-show="activeIndex == 0" v-if="$route.query['id'] > 0 && form.product_id == 106">
      <product-head
        style="margin-left: 120px"
        :params="params"
        @changeHead="changeHead"
      ></product-head>
    </div>
    <div v-show="activeIndex==1" v-if="$route.query['id'] > 0 && form.product_id > 0 && form.column_config && Object.keys(form.column_config).length > 0">
      <columnLimit :customer_id="$route.query['id']" :product_id="form.product_id" :config="form.column_config" @changeColumn="changeColumn"></columnLimit>
    </div>
    <div v-show="activeIndex==2" v-if="$route.query['id'] > 0 && form.product_id > 0 && form.quota_config.length > 0">
      <quotaLimit :customer_id="$route.query['id']" :product_id="form.product_id" :list="form.quota_config" @changeQuota="changeQuota"></quotaLimit>
    </div>
    <div v-show="activeIndex==3" v-if="$route.query['id'] > 0 && form.product_id > 0">
      <deviceBind :customer_id="$route.query['id']" :product_id="form.product_id" :list="form.device_config" @changeDevice="changeDevice"></deviceBind>
    </div>
    <div v-if="activeIndex==4 && $route.query['id'] > 0 && form.product_id > 0">
      <recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></recorder>
    </div>
  </div>
</template>
<script>
import ProductHead from "~/views/order/partial/product_head.vue"; //加载基本设置
import Recorder from "~/views/order/recoder/base.vue";
import columnLimit from "~/views/order/vr/columnLimit.vue";
import quotaLimit from "~/views/order/vr/quotaLimit.vue";
import deviceBind from "~/views/order/vr/deviceBind.vue";
import OrderService from "~/services/order";
export default {
  components: {
    ProductHead,
    Recorder,
    columnLimit,
    quotaLimit,
    deviceBind,
  },
  props: {
    params: {
      required: true,
    },
  },
  data() {
    return {
      activeIndex: "0",
      loading: false,
      form: {
        //基本设置
        order_id: "",
        product_id: "",
        type: '',
        end_at: '',
        start_at: '',
        memo: '',
        is_enable: false,
        column_config: {},
        quota_config: [],
        device_config: []
      },
    };
  },
  created() {
    this.form = Object.assign(this.form, this.params.config);
    this.form.order_id = this.params.order_id;
    this.form.product_id = this.params.product_id;
    this.form.type = this.params.open_state;
    this.form.end_at = this.params.end_at;
    this.form.start_at = this.params.start_at;
    console.log("进入：", this.params, this.params.config.type, this.form);
  },
  methods: {
    handleOpen(key, keyPath) {
      this.activeIndex = key;
    },
    /**
     * 提交
     * */
    submit() {
      console.log(112312, this.form);
      OrderService.reviseProduct(this.form).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg == "success" ? Params.REVISE_NOTICE : res.msg,
            type: "success",
          });
        }
      });
    },
    /**
     * 修改头部信息（开通时间及产品类型）
     * */
    changeHead(data) {
      console.log('更新基本设置', data);
      this.form.type = data.type;
      this.form.start_at = data.start_at;
      this.form.end_at = data.end_at;
      this.form.memo = data.memo;
      this.form.is_enable = data.is_enable;
    },

    /**
     * 修改了栏目限制
     * */
     changeColumn(data) {
      console.log('修改了栏目限制：', data);
      this.form.column_config.mode = data.mode;
      this.form.column_config.subject_list = data.subject_list;
      this.form.column_config.xueduan = data.xueduan;
    },
    /**
     * 修改了额度限制
     * */
     changeQuota(data) {
      console.log('修改了额度限制', data);
      this.form.quota_config = data;
    },
    /**
     * 修改了设备限制
     * */
     changeDevice(data) {
      console.log('修改了设备绑定', data);
      this.form.device_config = data;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/order/vrConfigure.vue